<template>
  <v-footer dark padless>
    <v-row>
      <v-col>
        <v-card class="flex" flat tile>
          <v-card-title class="footerMap">
            <v-row no-gutters>
              <v-col xs="12" sm="12" md="6" lg="6" xl="6" class="pl-5">
                <v-img
                  alt="Logotipo do PEJA Bauru escrito na cor branca"
                  class="shrink"
                  contain
                  :src="require('@/assets/svg/logo_branco.svg')"
                  transition="scale-transition"
                  height="8vh"
                  width="150"
                />
              </v-col>
              <v-col
                xs="12"
                sm="12"
                md="6"
                lg="6"
                xl="6"
                class="
                  d-flex
                  justify-xl-end
                  justify-lg-end
                  justify-md-end
                  justify-sm-end
                  justify-center
                  pt-2
                "
              >
                <v-btn
                  v-for="icon in icons"
                  :key="icon"
                  class="mx-4"
                  dark
                  icon
                  @click="openUrl(icon)"
                >
                  <v-icon size="24px">
                    {{ icon }}
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    icons: ['mdi-facebook', 'mdi-youtube', 'mdi-instagram'],
  }),
  methods: {
    openUrl(value) {
      switch (value) {
        case 'mdi-facebook':
          window.open('https://www.facebook.com/pejabauru/');
          break;
        case 'mdi-youtube':
          window.open(
            'https://www.youtube.com/channel/UCoKv1pXDZ01-_-KxZ0vfimg'
          );
          break;
        case 'mdi-instagram':
          window.open('https://www.instagram.com/peja_bauru/');
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style scoped>
.footerMap {
  background-color: #137cc0;
}
</style>
